import { Link } from 'react-router-dom';
import Navbar from '../../components/layout/Navbar';
import Footer from '../../components/layout/Footer';

const ServicesPage = () => {
  const services = [
    {
      icon: 'ri-hammer-line',
      title: 'General Building',
      description: 'Our general building services cover all aspects of construction and structural work. Whether you need an extension, loft conversion, or complete renovation, our experienced team delivers exceptional results.',
      details: [
        'Extensions and conversions',
        'Structural alterations and repairs',
        'New build projects',
        'Renovation and refurbishment',
        'Brickwork and masonry',
        'Carpentry and joinery',
      ],
      image: 'https://public.readdy.ai/ai/img_res/5cf4e4959f0370fb30221bb72ed47ddb.jpg',
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Kitchen Refurbishment',
      description: 'Transform your kitchen into a beautiful, functional space. We handle everything from design consultation to final installation, ensuring your new kitchen exceeds expectations.',
      details: [
        'Complete kitchen design service',
        'Cabinet installation and fitting',
        'Worktop supply and installation',
        'Plumbing and electrical work',
        'Tiling and flooring',
        'Appliance installation',
      ],
      image: 'https://readdy.ai/api/search-image?query=stunning%20modern%20kitchen%20renovation%20with%20white%20shaker%20cabinets%20marble%20countertops%20and%20stainless%20appliances%20in%20bright%20contemporary%20home%20showing%20professional%20installation%20and%20clean%20design&width=600&height=400&seq=kitchen-refurb-service&orientation=landscape',
    },
    {
      icon: 'ri-drop-line',
      title: 'Bathroom Refurbishment',
      description: 'Create your dream bathroom with our comprehensive refurbishment service. From contemporary wet rooms to traditional family bathrooms, we deliver quality installations that last.',
      details: [
        'Complete bathroom design',
        'Suite installation (bath, shower, toilet, basin)',
        'Wet room and walk-in shower installation',
        'Tiling and waterproofing',
        'Plumbing and heating',
        'Lighting and ventilation',
      ],
      image: 'https://readdy.ai/api/search-image?query=luxury%20modern%20bathroom%20with%20walk-in%20shower%20glass%20enclosure%20white%20tiles%20and%20contemporary%20fixtures%20showing%20professional%20renovation%20work%20in%20bright%20clean%20setting%20with%20elegant%20design&width=600&height=400&seq=bathroom-refurb-service&orientation=landscape',
    },
    {
      icon: 'ri-tools-line',
      title: 'Plumbing Services',
      description: 'Professional plumbing services for all your property needs. Our qualified plumbers handle everything from emergency repairs to complete system installations with expertise and care.',
      details: [
        'Emergency plumbing repairs',
        'Boiler installation and servicing',
        'Central heating systems',
        'Bathroom and kitchen plumbing',
        'Leak detection and repairs',
        'Pipe work and drainage',
      ],
      image: 'https://readdy.ai/api/search-image?query=professional%20plumber%20installing%20modern%20chrome%20fixtures%20and%20copper%20pipes%20in%20clean%20residential%20bathroom%20showing%20expert%20workmanship%20and%20quality%20plumbing%20installation%20with%20proper%20tools&width=600&height=400&seq=plumbing-service&orientation=landscape',
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Electrical Services',
      description: 'Certified electrical work carried out to the highest safety standards. Our qualified electricians provide reliable solutions for all domestic electrical requirements.',
      details: [
        'Full and partial rewiring',
        'Consumer unit upgrades',
        'Lighting installation and design',
        'Socket and switch installation',
        'Electrical safety testing',
        'Fault finding and repairs',
      ],
      image: 'https://readdy.ai/api/search-image?query=certified%20electrician%20working%20on%20modern%20electrical%20panel%20and%20wiring%20installation%20in%20residential%20property%20showing%20professional%20electrical%20work%20with%20safety%20equipment%20and%20proper%20techniques&width=600&height=400&seq=electrical-service&orientation=landscape',
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Decorating & Painting',
      description: 'Professional decorating services to refresh and transform your property. Our skilled decorators deliver flawless finishes on every project, interior and exterior.',
      details: [
        'Interior painting and decorating',
        'Exterior painting and rendering',
        'Wallpaper hanging',
        'Plastering and skimming',
        'Woodwork and trim painting',
        'Commercial decorating',
      ],
      image: 'https://readdy.ai/api/search-image?query=professional%20painter%20decorating%20interior%20room%20walls%20with%20roller%20and%20brush%20showing%20smooth%20finish%20and%20quality%20workmanship%20in%20bright%20residential%20space%20with%20clean%20painting%20technique&width=600&height=400&seq=decorating-service&orientation=landscape',
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Property Maintenance',
      description: 'Comprehensive maintenance services to keep your property in excellent condition. We provide regular maintenance contracts and one-off repairs for landlords and homeowners.',
      details: [
        'Regular maintenance contracts',
        'Emergency repairs',
        'Landlord services',
        'Gutter cleaning and repairs',
        'General handyman services',
        'Property inspections',
      ],
      image: 'https://readdy.ai/api/search-image?query=property%20maintenance%20worker%20repairing%20and%20maintaining%20residential%20building%20exterior%20showing%20professional%20service%20and%20quality%20workmanship%20with%20tools%20and%20equipment%20in%20daylight&width=600&height=400&seq=maintenance-service&orientation=landscape',
    },
    {
      icon: 'ri-home-gear-line',
      title: 'External Works',
      description: 'Enhance your property exterior with our comprehensive external works service. From driveways to garden walls, we deliver durable, attractive solutions.',
      details: [
        'Driveways and paving',
        'Fencing and gates',
        'Garden walls and brickwork',
        'Rendering and cladding',
        'Roofing repairs and replacement',
        'Guttering and fascias',
      ],
      image: 'https://readdy.ai/api/search-image?query=professional%20workers%20installing%20block%20paving%20driveway%20and%20landscaping%20front%20garden%20of%20residential%20property%20showing%20quality%20external%20building%20work%20in%20bright%20outdoor%20setting&width=600&height=400&seq=external-works-service&orientation=landscape',
    },
  ];

  const processSteps = [
    {
      number: '1',
      title: 'Contact Us',
      description: 'Get in touch via phone, email or our quote request form',
    },
    {
      number: '2',
      title: 'Site Visit & Quote',
      description: 'We review the details provided and arrange a site visit where required to assess the works and provide a quote',
    },
    {
      number: '3',
      title: 'Work Begins',
      description: 'Our skilled team starts work at a time convenient for you',
    },
    {
      number: '4',
      title: 'Final Inspection',
      description: 'We ensure you\'re completely satisfied with the finished work',
    },
  ];

  return (
    <div className="min-h-screen bg-white overflow-x-hidden max-w-[100vw]">
      <Navbar />

      {/* Hero Banner */}
      <section className="pt-32 pb-16 px-4 sm:px-6 lg:px-12 bg-[#F5F3EF]">
        <div className="max-w-[1400px] mx-auto text-center">
          <nav className="text-xs sm:text-sm text-gray-600 mb-4 break-words">
            <Link to="/" className="hover:text-black cursor-pointer">Home</Link>
            <span className="mx-2">&gt;</span>
            <span className="text-black">Services</span>
          </nav>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-black mb-4 break-words">
            Our Building &amp; Property Services
          </h1>
          <p className="text-base sm:text-lg lg:text-xl text-gray-700 max-w-2xl mx-auto break-words">
            Professional solutions for every property need
          </p>
        </div>
      </section>

      {/* Services Detail Grid */}
      <section className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-12">
        <div className="max-w-[1400px] mx-auto space-y-12 sm:space-y-16 lg:space-y-20">
          {services.map((service, index) => (
            <div
              key={index}
              className={`grid lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              {/* Image */}
              <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-[250px] sm:h-[350px] lg:h-[400px] object-cover rounded-2xl shadow-lg"
                />
              </div>

              {/* Content */}
              <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-4xl sm:text-5xl text-gray-700`}></i>
                </div>
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-black mb-4 break-words">{service.title}</h2>
                <p className="text-sm sm:text-base lg:text-lg text-gray-700 mb-6 leading-relaxed break-words">
                  {service.description}
                </p>
                <ul className="space-y-2 mb-6 sm:mb-8">
                  {service.details.map((detail, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-black text-lg sm:text-xl mt-0.5 flex-shrink-0"></i>
                      <span className="text-sm sm:text-base text-gray-700 break-words">{detail}</span>
                    </li>
                  ))}
                </ul>
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-2 bg-black text-white px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg text-sm sm:text-base font-medium hover:bg-gray-800 transition-all cursor-pointer max-w-full"
                >
                  <span className="break-words">Request a quote for {service.title.toLowerCase()}</span>
                  <i className="ri-arrow-right-line flex-shrink-0"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Process Section */}
      <section className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-12 bg-[#F9F9F9]">
        <div className="max-w-[1400px] mx-auto">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-black text-center mb-12 sm:mb-16 break-words">
            Our Simple Process
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {processSteps.map((step, index) => (
              <div key={index} className="relative text-center">
                <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-[#F5F3EF] rounded-full mx-auto mb-4 border-4 border-black">
                  <span className="text-2xl sm:text-3xl font-bold text-black">{step.number}</span>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-black mb-3 break-words">{step.title}</h3>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed break-words">{step.description}</p>
                {index < processSteps.length - 1 && (
                  <div className="hidden lg:block absolute top-10 left-[60%] w-[80%] border-t-2 border-dashed border-gray-300"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-12 bg-[#2B2B2B]">
        <div className="max-w-[800px] mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4 break-words">
            Ready to Discuss Your Project?
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-300 mb-6 sm:mb-8 break-words">
            Contact us today for a free, no-obligation quote
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-[#F5F3EF] text-black px-6 sm:px-8 lg:px-10 py-3 sm:py-4 lg:py-5 rounded-full text-base sm:text-lg font-semibold hover:bg-white transition-all whitespace-nowrap cursor-pointer"
          >
            Get Your Free Quote
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicesPage;
